module.exports = __webpack_public_path__ + "static/img/firefox.f979860f.png";